import { render, staticRenderFns } from "./select-address.vue?vue&type=template&id=63e58d74&scoped=true&"
import script from "./select-address.vue?vue&type=script&lang=js&"
export * from "./select-address.vue?vue&type=script&lang=js&"
import style0 from "./select-address.vue?vue&type=style&index=0&id=63e58d74&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e58d74",
  null
  
)

export default component.exports